import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);
const routes = [
    // 无权限
    { path: '/nopermission', component: () => import('@/views/nopermission'), hidden: true },
    {
        path: '/',
        name: 'index',
        redirect: '/home',
        meta: {
            name: '',
            type: 1,
            synergy: true
        },
        component: () => import('@/views/Index.vue'),
        children: [
            {
                path: 'home',
                name: 'home',
                component: () => import('@/views/front/index/Index.vue'),
                meta: {
                    name: '首页',
                    type: 1,
                    synergy: true
                },
            },
            {
                path: 'search',
                name: 'search',
                component: () => import('@/views/front/search/Search.vue'),
                meta: {
                    name: '高级检索',
                    type: 1,
                    synergy: true
                },
            },
            {
                path: 'list',
                name: 'list',
                component: () => import('@/views/front/list/List.vue'),
                meta: {
                    name: '检索结果',
                    type: 1,
                    synergy: true
                },
            },
            {
                path: 'detail/:id',
                name: 'detail',
                component: () => import('@/views/front/detail/Detail.vue'),
                meta: {
                    name: '详情页',
                    type: 1,
                    synergy: true
                },
            },
            {
                path: '404',
                name: '404',
                component: () => import('@/views/404.vue'),
                meta: {
                    name: '异常',
                    type: 1,
                    synergy: true
                },
            },
        ],
    },
];
const router = new Router({
    // 此处使用默认的hash模式，即在浏览器地址栏中会出现那个#
    // 若要使用history模式，则需要在后端做相应的配置
    // 相关解释说明：
    // https://router.vuejs.org/zh/guide/essentials/history-mode.html
    // https://www.cnblogs.com/yszblog/p/10255458.html
    // mode: 'history',
    routes
});
//  忽略点击重复路由会抛出异常的问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
// 通过路由修改title
// router.beforeEach((to, from, next) => {
//   /* 路由发生变化修改页面title */
//   document.title = 'wps-view';
//   next()
// });
export default router
